// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__1ATIJ","label":"Search_label__22ZlC","inpName":"Search_inpName__2QVuT","button_submit":"Search_button_submit__3o8d0"};